// extracted by mini-css-extract-plugin
export default {"person-role-cell":"PersonRoleCell_person-role-cell__la7Ll","role-select":"PersonRoleCell_role-select__HsDVv"};